import {
  appVersion,
  name,
  numbers,
  specialChars,
  description,
  topRightUELogoEnabled,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes, applicationSubmittedTo
} from './base.config';

export const environment = {
  appVersion,
  specialChars,
  numbers,
  name,
  description,
  topRightUELogoEnabled,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes,
  applicationSubmittedTo,
  production: false,
  apiBasePath: 'https://smartfactor-ropczyce.test.aspello.pl/system/api/v1',
  ssl: false
};
